import { useMutation } from "@tanstack/react-query";
import { getCsrfCookie } from "../lib/utils";

export type TopicIdeaDto = {
  id: number;
  topic: string;
  category_key: string;
  status: "PENDING" | "SHOWN" | "ACCEPTED" | "SKIPPED" | "EXPIRED";
};

export function useTopicIdeaNext() {
  return useMutation({
    mutationFn: async (arg?: { language?: string; text_type?: string }) => {
      const res = await fetch("/api/reeprise/generated_texts/topic-ideas/next/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFTOKEN": getCsrfCookie(),
        },
        body: JSON.stringify({
          language: arg?.language,
          text_type: arg?.text_type,
        }),
      });
      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          throw new Error("AUTH_REQUIRED");
        }
        throw new Error("could not fetch topic idea");
      }
      return (await res.json()) as TopicIdeaDto;
    },
  });
}
